import { Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardTitle } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AuthSelectors, UserState } from '@ngrx-store';

import { TotpEnrollDialogComponent } from './totp-enroll-dialog.component';
import { TotpResetDialogComponent } from './totp-reset-dialog.component';

@Component({
  imports: [MatCardTitle, MatButtonModule],
  selector: 'avs-totp-auth',
  templateUrl: './totp-auth.component.html',
})
export class TotpAuthComponent {
  protected user: Signal<UserState | undefined>;
  private dialog = inject(MatDialog);
  private store = inject(Store);

  constructor() {
    this.user = toSignal(this.store.select(AuthSelectors.selectUser));
  }

  protected enable() {
    this.dialog.open(TotpEnrollDialogComponent, {
      backdropClass: 'backdrop-modal-panel',
      disableClose: true,
    });
  }

  protected reset() {
    this.dialog.open(TotpResetDialogComponent, {
      backdropClass: 'backdrop-modal-panel',
      disableClose: true,
    });
  }
}
